<form novalidate>
  <kendo-dialog title="{{'_Shared_ModalPopUp_Trasnfer_Assist_Title_Text_' | translate}}" *ngIf="dialogOpened" class="no-close-dialog">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>

    <div class="col-md-12 form-group">
      <p>{{'_Shared_ModalPopUp_Transfer_Assist_Body_Text_' | translate : {val1: transferFrom, val2: transferAssistDetails.length} }}</p>
    </div>

    <div class="col-md-12 form-group">
      <div class="tbl-impersonate-scrollable">
        <table width="100%" class="tbl-imposonate-users">
          <tr>
            <th>{{'_General_Location_Text_' | translate }}</th>
            <th>{{'_General_Visitor Name_Text_' | translate }}</th>
          </tr>
          <tr *ngFor="let data of transferAssistDetails">
            <td>{{data.locationName}}</td>
            <td>{{data.visitorName}}</td>
          </tr>
        </table>
      </div>

    </div>

    <!-- Button Panel -->
    <div class="cc-btn-panel multiple-btn-panel">
      <div>
        <button type="button" id="saveBtn" class="btn btn-primary" (click)="confirmTransfer()">{{'_General_Button_Ok_Text_' | translate }}</button>
      </div>
    </div>
  </kendo-dialog>
</form>
